import UniversalModal from './universalModal'

export default UniversalModal
